// extracted by mini-css-extract-plugin
export default {"footerImage":"Footer_footerImage__rauGa"};